import { Auth0ContextInterface } from '@auth0/auth0-react';

export interface Auth0User {
  sub: string;
  name: string;
  family_name?: string;
  middle_name?: string;
  given_name?: string;
  nickname?: string;
  preferred_username?: string;
  profile?: string;
  picture: string;
  website?: string;
  email: string;
  email_verified: boolean;
  gender?: string;
  birthdate?: string;
  zoneinfo?: string;
  locale?: string;
  phone_number?: string;
  phone_number_verified?: boolean;
  address?: any;
  updated_at?: string;
  'https://limberhealth.com/is-admin': boolean;
  'https://limberhealth.com/organization-id'?: number;
}

export const IS_ADMIN_KEY = 'https://limberhealth.com/is-admin';
export const ORGANIZATION_ID_KEY = 'https://limberhealth.com/organization-id';

export interface Auth0Context extends Auth0ContextInterface {
  user: Auth0User;
}
